import { claimTrial } from '../helpers/claim-trial';
import { getDeviceIdByRadioId } from '@sxm-de/dev-kits/web-sdk/domains/devices';
import { DomainInitPayload } from '@sxm-de/dev-kits/web-sdk/types';
import { normalizeRadioIdForServiceCallWithSupportForUUID } from '@sxm-de/dev-kits/web-sdk/utils';

interface ClaimTrialForRadioIdFnPayload {
    radioId: string;
}

export type ClaimTrialForRadioIdFn = (
    payload: ClaimTrialForRadioIdFnPayload,
) => Promise<void>;

export function initClaimTrialForRadioIdFn({
    dependencies,
}: DomainInitPayload): ClaimTrialForRadioIdFn {
    return async ({ radioId }: ClaimTrialForRadioIdFnPayload) => {
        const deviceId = await getDeviceIdByRadioId(
            {
                radioId:
                    normalizeRadioIdForServiceCallWithSupportForUUID(radioId),
            },
            dependencies,
        );

        await claimTrial(
            {
                vehicleDeviceId: deviceId,
            },
            dependencies,
        );
    };
}
